import { RangeValue } from '@common/types/queryState';
import { Flex, Slider, Text } from '@radix-ui/themes';

interface FacetSliderProps {
    value?: RangeValue;
    min: number;
    max: number;
    step: number;
    unit: string;
    onChange: (val: RangeValue) => void;
}

export const FacetSlider = ({
    value,
    min,
    max,
    step,
    unit,
    onChange,
}: FacetSliderProps) => {
    const currentRange = [value?.min ?? min, value?.max ?? max];

    return (
        <Flex direction='column' gap='3'>
            <Slider
                size={'1'}
                defaultValue={[min, max]}
                value={currentRange as [number, number]}
                step={step}
                min={min}
                max={max}
                onValueChange={([newMin, newMax]) =>
                    onChange({
                        min: newMin,
                        max: newMax,
                        operator: 'inclusive',
                    })
                }
            />

            <Flex justify='between'>
                <Text size='1' color='gray'>
                    {currentRange[0]}
                    {unit}
                </Text>

                <Text size='1' color='gray'>
                    {currentRange[1]}
                    {unit}
                </Text>
            </Flex>
        </Flex>
    );
};
